import { useState } from "react";

const useProcessingModal = () => {
  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [processingProgress, setProcessingProgress] = useState([]);

  const withProgress = async (files, task) => {
    setProcessingModalOpen(true);
    setProcessingProgress(files.map((file) => ({ ...file, percent: 0 })));

    const progressFor = (fileId) => (processed, total) =>
      setProcessingProgress((prev) =>
        prev.map((file) =>
          file.fileId === fileId
            ? { ...file, percent: total > 0 ? Math.round((processed / total) * 100) : 0 }
            : file
        )
      );

    try {
      await task(progressFor);
      setProcessingProgress((prev) => prev.map((file) => ({ ...file, percent: 100 })));
      await new Promise((resolve) => setTimeout(resolve, 500)); // show 100% and prevent flicker of small fast to process files
    } finally {
      setProcessingModalOpen(false);
      setProcessingProgress([]);
    }
  };

  return { processingModalOpen, processingProgress, withProgress };
};

export default useProcessingModal;
